import request from './request';

/**
 * 配置快照API - V2
 */

// 创建配置快照
export function createSnapshot(data) {
  return request({
    url: '/eval/snapshots',
    method: 'post',
    data
  });
}

// 获取测试用例的所有快照
export function getSnapshotsByTestCase(testCaseId) {
  return request({
    url: `/eval/snapshots/test-case/${testCaseId}`,
    method: 'get'
  });
}

// 获取快照详情
export function getSnapshotDetail(id) {
  return request({
    url: `/eval/snapshots/${id}`,
    method: 'get'
  });
}

// 更新快照信息
export function updateSnapshot(id, data) {
  return request({
    url: `/eval/snapshots/${id}`,
    method: 'put',
    data
  });
}

// 删除快照
export function deleteSnapshot(id) {
  return request({
    url: `/eval/snapshots/${id}`,
    method: 'delete'
  });
}

// 对比两个快照
export function compareSnapshots(snapshotId1, snapshotId2) {
  return request({
    url: '/eval/snapshots/compare',
    method: 'post',
    data: {
      snapshot_id_1: snapshotId1,
      snapshot_id_2: snapshotId2
    }
  });
}

